import React from 'react'
import { ParentDashboardWrapper } from '@/components/ParentDashboardWrapper'

/**
 * Parent home page - Shows tile dashboard with A/B testing
 * Route: /dashboard/home
 */
export const ParentHomePage: React.FC = () => {
  return <ParentDashboardWrapper />
}
